module.exports = "<div class=\"y-tag\" data-bind=\"css:typeClass,style:style\">\n  <span class=\"y-tag-text\" data-bind=\"text:text,click:handleClick,style:{color: style.color}\"></span>\n  <i data-bind=\"visible:closeable,click:handleClose,style:{color: style.color}\" class=\"y-tag-close\">+</i>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/tag/index.html
// module id = 482
// module chunks = 0